import { render, staticRenderFns } from "./videoPlayer.vue?vue&type=template&id=aa8904ac&scoped=true"
import script from "./videoPlayer.vue?vue&type=script&lang=ts"
export * from "./videoPlayer.vue?vue&type=script&lang=ts"
import style0 from "./videoPlayer.vue?vue&type=style&index=0&id=aa8904ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8904ac",
  null
  
)

export default component.exports